import Cookies from "js-cookie"
import {RPID_COOKIE} from "../../config/constants"

export const getRpId = (): string | undefined => {
    const rpidCookie = Cookies.get(RPID_COOKIE)
    if (rpidCookie === undefined) return
    const splitArr = rpidCookie.split("=")
    if (splitArr.length === 2) return splitArr[1]
    return undefined
}
